import React, { useContext, useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import LiveMatch from './live/LiveMatch';
import PrematchSection, { SuperkurzyHierarchy } from './PrematchSection';
import ResultsSection from './ResultsSection';
import BoxOptionsContext from '../context/BoxOptionsContext';
import { loadBox } from '@/nikeone/handlers';
import { parseBoxId } from 'nike-ui/src/components/turboLive/push/utils';
import { List } from 'immutable';
import { tournamentMatchIdsOrdered$$ } from 'nike-ui/src/components/turboLive/push/overview/hybrid-subs';
import { matchesOnTickets$ } from '@/nikeone/subs';

export const HybridTourContent = React.memo(function HybridTourContent({ boxStore, boxId, expanded }) {
    useEffect(() => {
        if (expanded) {
            dispatch(loadBox(boxId, boxStore));
        }
    }, [expanded, boxId, boxStore]);
    const derefSub = useReframe();
    const { live, prematch, results, shortcutMarkets, usePrematchOnly } = useContext(BoxOptionsContext);
    const loadingDone = derefSub(['nikeone/loading/box/done', boxId]);
    const hasNoSection = derefSub(['nikeone/box/hasNoSection', boxStore, boxId]);

    if (loadingDone && hasNoSection) {
        return <EmptyTournament />;
    }

    const prematchOnly = usePrematchOnly && derefSub(['nikeone/filter/isPrematchOnly', boxStore]);

    return (
        <div data-atid="nikeOne-tournament" className="nikeone-tournament">
            {live && !prematchOnly && <HybridLiveMatchesTlv boxStore={boxStore} boxId={boxId} />}
            {prematch && <PrematchSection boxStore={boxStore} boxId={boxId} shortcutMarkets={shortcutMarkets} />}
            {results && <ResultsSection boxStore={boxStore} boxId={boxId} />}
        </div>
    );
});

function HybridLiveMatchesTlv({ boxStore, boxId }) {
    const derefSub = useReframe();
    const { tournamentId } = parseBoxId(boxId);
    let matchIds = List();
    if (tournamentId) {
        matchIds = derefSub(tournamentMatchIdsOrdered$$(tournamentId));

        if (!matchIds.size) {
            return null;
        }

        return matchIds.map(id => <LiveMatch matchId={id} key={id} />);
    } else if (boxId === 'onTicketsBoxId') {
        matchIds = derefSub(matchesOnTickets$(boxStore));
        if (!matchIds.size) {
            return null;
        }

        return matchIds.map(id => <LiveMatch matchId={id} key={id} />);
    }
}

export function EmptyTournament() {
    return (
        <div className="info-note">
            <p>{i18n('market.info.none')}</p>
        </div>
    );
}

function LoadingTournament() {
    return (
        <div className="layout-offer-rw">
            <div className="top-live pending">
                <div className="item-box">
                    <div className="top-live-item">
                        <div className="wave-animation" />
                        <div className="wave-animation" />
                    </div>
                    <div className="top-live-item">
                        <div className="wave-animation" />
                        <div className="wave-animation" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SuperkurzyTournament({ boxStore, boxId }) {
    const derefSub = useReframe();
    const loadingDone = derefSub(['nikeone/loading/box/done', boxId]);
    if (!loadingDone) {
        return <LoadingTournament />;
    }
    const hasNoSection = derefSub(['nikeone/box/hasNoSection', boxStore, boxId]);
    if (loadingDone && hasNoSection) {
        return <EmptyTournament />;
    }
    return (
        <div className="nikeone-tournament layout-offer-rw">
            <SuperkurzyHierarchy boxStore={boxStore} boxId={boxId} />
        </div>
    );
}
